/**
 * @desc: - 页脚- 全站主页脚
 * @author: ammo
 */
import React from 'react';

export default class OriginalMainFooter extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <footer className="footer-container">
        <div className="frame-container">
          <div className="logo"></div>
          <p>
            {window.vers === "df" && <img src={require("../../i/pc-day/df/footer-log.jpg")} alt="" />}Copyright Philippine
            Government PAGCOR Gaming License Certification
          </p>
        </div>
      </footer>
    );
  }
}
